$('.faq-wrapper .faq-item .tms').on('click', function () {
    var $item = $(this).closest('.faq-item');
    $('.faq-item').not($item).removeClass('open');
    $item.toggleClass('open');
});

